import { render } from "./RadioButtonGroup.vue?vue&type=template&id=2c72ba5c&scoped=true"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=js"

import "./RadioButtonGroup.vue?vue&type=style&index=0&id=2c72ba5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c72ba5c"]])

export default __exports__